export default "__VITE_ASSET__C30ZaXL7__"